import {Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
    static isProjectArchive() {
        return document.body.classList.contains('post-type-archive-project_detailed') || 
               document.body.classList.contains('post-type-archive-project_lab');
    }

    static closeFilterPanel() {
        const filterBtn = document.querySelector(".menu-item-filter");
        const filterModal = document.querySelector(".filters-modal");

        if (filterBtn) {
            filterBtn.classList.remove("active");
        }

        if (filterModal) {
            filterModal.classList.remove("active");
        }
    }

    static closeNavPanel() {
        document.body.classList.remove("navs-open");
        this.restoreHeaderTheme();

        const activeMenuItems = document.querySelectorAll(".header-main .menu-item-lev1.active");
        activeMenuItems.forEach((item) => {
            item.classList.remove("active");

            const lev2 = item.querySelector(".lev2");
            if (lev2) {
                lev2.classList.remove("show");
            }

            const lev2Items = item.querySelector(".lev2-items");
            if (lev2Items) {
                lev2Items.classList.remove("show");
            }

            const toggler = item.querySelector("button[data-header='toggler']");
            if (toggler) {
                toggler.setAttribute("aria-expanded", "false");
            }
        });
    }

    static init() {
        this.header = document.querySelector(".header-main");
        if (this.header) {
            this.navMain = this.header.querySelector(".navs");
            this.headerClass = this.header.className.replace("is-on-top", "");
            this.keepHeaderOnMobile = this.header.dataset.keepHeaderOnMobile;

            this.filterBtn = document.querySelector(".menu-item-filter");
            this.searchBtn = document.querySelector(".menu-item-search");
            this.filterModal = document.querySelector(".filters-modal");

            this.searchInput = document.getElementById('lab-search');
            if (this.searchInput) {
                this.searchWrapper = this.searchInput.closest('li.menu-item-lev1');
                if (this.searchWrapper) {
                    this.searchTrigger = this.searchWrapper.querySelector('svg:not(.search-input-cross svg)');
                    this.searchModal = this.searchWrapper.querySelector('.search-modal');

                    this.toggleSearch();
                }
            }

            if (this.navMain) {
                this.navMobileColor();
            }
            this.toggleFilter();
            this.resize();
        }
        GlobalVariables.resizeCallbacks.push(this);
    }

    static toggleFilter() {
        if (this.filterBtn) {
            this.filterBtn.addEventListener("click", () => {
                if (this.searchModal && this.searchModal.classList.contains('active')) {
                    this.searchModal.classList.remove('active');
                    this.searchBtn.classList.remove('active');
                }

                const willOpenFilter = this.filterModal && !this.filterModal.classList.contains("active");
                if (willOpenFilter && this.isProjectArchive()) {
                    this.closeNavPanel();
                }

                this.filterBtn.classList.toggle("active");
                this.filterModal.classList.toggle("active");
            });

            document.addEventListener('click', (e) => {
                if (this.filterBtn && !this.filterBtn.contains(e.target) && this.filterModal && !this.filterModal.contains(e.target)) {
                    this.filterModal.classList.remove('active');
                    this.filterBtn.classList.remove('active');
                }
            });
        }
    }

    static toggleSearch() {
        if (this.searchBtn && this.searchModal) {
            this.searchBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();

                if (this.filterBtn && this.filterBtn.classList.contains("active")) {
                    this.filterBtn.classList.remove("active");
                    this.filterModal.classList.remove("active");
                }

                this.searchModal.classList.toggle('active');
                this.searchBtn.classList.toggle('active');

                if (this.searchModal.classList.contains('active')) {
                    this.searchInput.focus();
                }
            });

            document.addEventListener('click', (e) => {
                if (this.searchWrapper && !this.searchWrapper.contains(e.target)) {
                    this.searchModal.classList.remove('active');
                    this.searchBtn.classList.remove('active');
                }
            });

            this.searchModal.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    }

    static toggleHeader() {
        Observer.create({
            type: "scroll", tolerance: 60, dragMinimum: 30, onStop: () => {
                if (window.scrollY < 100) {
                    this.header.className = this.headerClass;
                    this.header.classList.add("is-on-top");
                } else {
                    this.header.classList.remove("is-on-top");
                }
            }, onStopDelay: 0, onUp: () => {
                this.showHeader();
            }, onDown: () => {
                this.hideHeader();
            }
        });
    }

    static showHeader() {
        this.header.classList.remove('hide');
        this.header.classList.add('show');
    }

    static hideHeader() {
        if (window.scrollY > 100 && !this.keepHeaderOnMobile) {
            this.header.classList.remove('show');
            this.header.classList.add('hide');
        }
    }

    static navMobileColor() {
        if (!this.navMain) return;
        if (window.innerWidth > 991) {
            this.removeClassByPrefix(this.navMain, 'section-');
        } else {
            this.navMain.classList.add(this.header.dataset.sectionColor);
        }
    }

    static makeHeaderAsBannerTheme() {
        if (this.header.classList.contains("is-on-top")) {
            this.removeClassByPrefix(this.header, 'section-');
            this.header.classList.add(this.header.dataset.sectionColor);
        }
    }

    static restoreHeaderTheme() {
        if (this.header.classList.contains("is-on-top")) {
            this.removeClassByPrefix(this.header, 'section-');
            this.header.classList.add(this.header.dataset.bannerTheme);
        }
    }

    static removeClassByPrefix(node, prefix) {
        if (!node) return;
        const regx = new RegExp('\\\\b' + prefix + '[^ ]*[ ]?\\\\b', 'g');
        node.className = node.className.replace(regx, '');
        return node;
    }

    static resize() {
        this.navMobileColor();
        if (window.innerWidth > 991) {
            this.toggleHeader();
        }
    }
}
